import { render, staticRenderFns } from "./preview-dialog.vue?vue&type=template&id=313c7c3a&scoped=true&"
import script from "./preview-dialog.vue?vue&type=script&lang=ts&"
export * from "./preview-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./preview-dialog.vue?vue&type=style&index=0&id=313c7c3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313c7c3a",
  null
  
)

export default component.exports